import Vue from 'vue'
import router from '../router'
import Meta from 'vue-meta'
import axios from 'axios'

/* register components */
// let components = [
//   pageTitle
// ]
// for (let com of components) {
//   com.hasOwnProperty('name') ? Vue.component(com.name, com) : Vue.use(com)
// }
Vue.prototype.$axios = axios

Vue.use(Meta)

export {Vue, router}



// WEBPACK FOOTER //
// ./src/common/globalImport.js